/**
 * Shared helpers for JSON calls to our own backend.
 */

/**
 * Get CSRF token from meta tag
 */
export function getCsrfToken(): string {
  const meta = document.querySelector<HTMLMetaElement>(
    'meta[name="csrf-token"]',
  );
  return meta?.content ?? "";
}

/**
 * Headers for JSON POSTs.
 * X-Requested-With marks the call as AJAX so CodeIgniter answers errors
 * (e.g. an expired CSRF token) with a status code instead of a redirect.
 */
export function jsonHeaders(): Record<string, string> {
  return {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": getCsrfToken(),
  };
}

/**
 * Parse a JSON response body without throwing on HTML error pages.
 */
export async function readJson(response: Response): Promise<unknown> {
  try {
    return await response.json();
  } catch {
    return null;
  }
}

/**
 * Best-effort error message from a CodeIgniter API error response.
 */
export function errorMessage(data: unknown, fallback: string): string {
  if (typeof data === "object" && data !== null) {
    const obj = data as {
      messages?: Record<string, unknown>;
      error?: unknown;
      message?: unknown;
    };
    const fromMessages = obj.messages
      ? Object.values(obj.messages).find((v) => typeof v === "string")
      : undefined;
    if (typeof fromMessages === "string") return fromMessages;
    if (typeof obj.error === "string") return obj.error;
    if (typeof obj.message === "string") return obj.message;
  }
  return fallback;
}
